import * as React from "react";
import { useState } from "react";
import { Link } from "@mui/material";
import { motion } from "motion/react";
import { useNavigate } from "react-router";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookF,
  faInstagram,
  faThreads,
} from "@fortawesome/free-brands-svg-icons";

function Footer() {
  const navigation = useNavigate();
  return (
    <div className="footer-container">
      <p className="footer-text">
        © Copyright 2025-2026{" "}
        <Link
          variant="body2"
          underline="none"
          onClick={() => navigation("/")}
          className="footer-link"
        >
          SoyaraCouture.
        </Link>{" "}
        All intellectual property rights reserved.
      </p>
      <div className="social-media-container">
        <a
          href="https://www.facebook.com/share/1CQdY9rWX9/"
          target="_blank"
          rel="noopener noreferrer"
          className="social-media-block facebook"
        >
          <div className="social-media-icon">
            <FontAwesomeIcon icon={faFacebookF} />
          </div>
          <p className="social-media-tooltip">Facebook</p>
        </a>

        <a
          href="https://www.instagram.com/soyara_rental_couture/?hl=en"
          target="_blank"
          rel="noopener noreferrer"
          className="social-media-block instagram"
        >
          <div className="social-media-icon">
            <FontAwesomeIcon icon={faInstagram} />
          </div>
          <p className="social-media-tooltip">Instagram</p>
        </a>

        <a
          href="https://www.threads.com/@soyara_rental_couture?xmt=AQF0gfPatswXPhgK5PR_EUz6e5kslVTGblqhIROJpDB1xLg"
          target="_blank"
          rel="noopener noreferrer"
          className="social-media-block thread"
        >
          <div className="social-media-icon">
            <FontAwesomeIcon icon={faThreads} />
          </div>
          <p className="social-media-tooltip">Thread</p>
        </a>
      </div>
    </div>
  );
}
export default Footer;
